exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-item {\n  padding: 1px 10px;\n  margin: 4px 0;\n  background-color: #eeeeee; }\n  .result-item .result-item--row {\n    margin: 10px 0; }\n\n.price--old {\n  text-decoration: line-through;\n  color: red; }\n\n.price--new {\n  color: green; }\n", ""]);

// exports
